import { LOCATION_CHANGE } from 'react-router-redux'

const NAV_TOGGLE = 'blayzr/nav/TOGGLE'
const NAV_CLOSE = 'blayzr/nav/CLOSE'

const initialState = {
  open: false
}

let previousPath

export default function reducer (state = initialState, action = {}) {
  const { type, payload } = action
  switch (type) {
    case NAV_TOGGLE:
      return {
        ...state,
        open: !state.open
      }
    case NAV_CLOSE:
      return {
        ...state,
        open: false
      }
    case LOCATION_CHANGE:
      const newState = {
        ...state,
        open: false,
        previousPath // Note we are using the previously set path here..
      }
      previousPath = payload.pathname // and then setting the new path as the previous one here
      return newState
    default:
      return state
  }
}

export function toggleNav () {
  return {
    type: NAV_TOGGLE
  }
}

export function closeNav () {
  return {
    type: NAV_CLOSE
  }
}



// WEBPACK FOOTER //
// ./src/redux/nav.js